import { StepFieldsMap } from 'sos-common/js/commonTypes';

export const qualityregisterOrderStepValidationMap = {
  0: {
    fieldNames: ['QualityRegister', 'OtherQualityRegister'],
    stepId: 0
  },
  1: {
    fieldNames: ['ContactPerson.Name', 'ContactPerson.Email', 'Organisation'],
    stepId: 1
  }
} as StepFieldsMap;
